import { ComponentType, lazy, Suspense } from 'react';
import { LoadableLoader } from "./LoadableLoader";

export const loadable = <T=any, >(
        importFunc: () => Promise<{ default: ComponentType<T> }>,
        Fallback: (props: any) => JSX.Element = LoadableLoader
) => {
    const LazyComponent = lazy(importFunc);
    return (props) => {
        const fallback = Fallback
                ? <Fallback {...props} />
                : null;
        return (
                <Suspense fallback={fallback}>
                    <LazyComponent {...props} />
                </Suspense>
        );
    };
};
